export default "__VITE_ASSET__CEYbj0TF__"